app.service('operatorClientView', function (loading, front, modal, orderConfig) {
	var $self, config;
	var $operatorSource, $buttonSearch, $clientList, $detailsArea, $firstname;
	var $additionalHint, $clientSurname, $clientEmail, $clientPhone, $clientFirstname;

	function changeOperatorSource(source) {
		$operatorSource.removeClass('active').filter('[data-source=' + source + ']').addClass('active');
		config.operatorSource = source;
	}
	function setElements() {
		$self = $('#operator-client-box');
		config = orderConfig.getData();
		$clientList = $('#client-list', $self);
		$operatorSource = $('.js-operator-source', $self);
		$detailsArea = $('#details-area', $self);
		$firstname = $('#client-firstname-row');
		$additionalHint = $('#additional-hint', $self);
		$buttonSearch = $('.js-operator-client-search', $self);
		$clientSurname = $('#client-surname', $self);
		$clientFirstname = $('#client-firstname', $self);
		$clientEmail = $('#client-email', $self);
		$clientPhone = $('#client-phone', $self);
	}
	function checkValidate() {

		var validated = true;
		var textMessage = '';
		var phone = $clientPhone.val();
		var email = $clientEmail.val();
		var surname = $clientSurname.val();

		if (!/\d{9}/.test(phone) && phone.length > 0) {
			textMessage = 'Niepoprawny numer telefonu'
			validated = false;
		}

		if (email == '' && phone == '') {
			textMessage = 'Podaj prawidłowe kryteria wyszukiwania';
			validated = false;
		}

		if (email != '' && !front.getParam('emailReg').test(email)) {
			textMessage = 'Niepoprawny adres e-mail';
			validated = false;
		}

		if (surname != '' && email == '' && phone == '') {
			textMessage = 'Podaj dodatkowe kryteria wyszukiwania: e-mail lub telefon';
			validated = false;
		}

		if (surname != '' && surname.length < 3) {
			textMessage = 'Niepoprawne nazwisko';
			validated = false;
		}
		if (textMessage.length) {
			$additionalHint.html(textMessage);
		} else {
			$additionalHint.empty();
		}

		return validated;
	}
	function search() {
		if (checkValidate()) {
			loading.start();
			$.ajax({
				url: '/front-user-customer-details.ltr',
				data: {
					surname: $clientSurname.val(),
					firstName: $clientFirstname.val(),
					email: $clientEmail.val(),
					phone: $clientPhone.val(),
					operatorSource: config.operatorSource
				},
				success: function (result) {
					loading.stop();
					$detailsArea.removeClass('show-clients client-selected');
					if (result && result.length && typeof result === 'object') {
						$detailsArea.addClass('show-clients');
						$clientList.empty();
						result.forEach(client => {
							var $result = $(`
									<div class="client">
										<div class="row row-short-info">
											${client.shortInfo}
										</div>
										<div class="row row-phone">
											${client.phone}
										</div>
										<div class="row row-street">
											${client.street} ${client.houseNumber}${client.flatNumber.length ? '/' + client.flatNumber : ''}
										</div>
										<div class="row row-city">
											${client.zipCode}, ${client.city}
										</div>
									</div>`);
							$result.click(function () {
								$detailsArea.addClass('client-selected');
								$('.client', $self).removeClass('active');
								$(this).addClass('active');
								$('#login', $self).val(client.login);
							});
							$clientList.append($result);
						});
					} else {
						$detailsArea.removeClass('show-clients');
						modal.alert('Brak wyników');
					}
				},
				error: function () {
					loading.stop();
					modal.alert('Wystąpił błąd wyszukiwania. Spróbuj ponownie');
				}
			});
		}
	}
	function sendOperatorSource(callback) { 
		$.ajax({
			type: "POST",
			url: '/add-source-param.ltr',
			data: {
				operator_source: config.operatorSource,
				from: config.from
			},
			success: function (result) {
				if (result == 'ok') {
					callback();
				}
				else {
					loading.stop();
					modal.alert('Wybierz kanał sprzedaży.')
				}
			},
			error: function () {
				loading.stop();
				modal.alert('Błąd zapisu kanału sprzedaży');
			}
		});
	}
	function setEvents() {
		$('#operator-search-client', $self).on('input', function () {
			checkValidate();
		}).on('keypress', function (e) {
			if (e.which == 13) {
				search();
			}
		});
		$operatorSource.click(function () {
			changeOperatorSource($(this).data('source'));
		});
		$('#client-surname').on('input', function () {
			if ($(this).val().length > 2) {
				$firstname.show();
			} else {
				$firstname.hide().find('input').val('');
			}
		});
		$buttonSearch.click(function () {
			search();
		});
		$('.js-operator-client-login').click(function () {
			loading.start();
			sendOperatorSource(function () {
				var $form = $('#login-form', $self);
				$form.attr('action', '/order-get-customer-for-front-operator.ltr');
				$form.submit();
			});
		});
		$('.js-operator-client-registration', $self).click(function () {
			loading.start();
			sendOperatorSource(function () {
				var $form = $('#register-form', $self);
				$form.attr('action', '/order-get-customer-for-front-operator.ltr');
				$form.submit();
			});
		});
	}
	function init() {
		setElements();
		if ($self.length) {
			setEvents();
		}
	}
	return {
		init
	};
});
